import React from 'react';
import { colors } from '../../../../components/css';

/**
 * @typedef {"start" | "center" | "end"} Position
 * @typedef {"small" | "medium" | "large" } Size
 */

/**
 * Badge to display if a given property can be booked instantly
 *
 * @param {Object} props - The properties object.
 * @param {boolean} props.enabled - Flag to show if component is enabled or disabled
 * @param {Position} [props.position="center"] - Position of the badge
 * @param {Size} [props.size="medium"] - Size of the badge
 * @returns {JSX.Element} The InstantPropertyBadge component.
 */
export default function InstantPropertyBadge({ enabled, position, size }) {
  let alignment;

  switch (position) {
    case 'end':
      alignment = 'flex-end';
      break;
    case 'start':
      alignment = 'flex-start';
      break;
    default:
      alignment = 'center';
  }

  let width;
  switch (size) {
    case 'small':
      width = '16px';
      break;
    case 'medium':
      width = '24px';
      break;
    case 'large':
      width = '32px';
      break;
    default:
      width = '24px';
  }

  const componentColor = `${enabled ? colors.colorBlue03 : colors.colorGrey04}`;

  return (
    <div
      style={{
        cursor: 'default',
        display: 'flex',
        justifyContent: 'center',
        alignItems: alignment
      }}
    >
      <svg width={width} height={width} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width={24} height={24} rx="24" fill={componentColor} />
        <g clipPath="url(#clip0_257_9954)">
          <path
            d="M6 12.8211C6 13.0984 6.24896 13.3046 6.59751 13.3046H11.2863L8.81328 19.0633C8.48963 19.7955 9.37759 20.1865 9.93361 19.5893L17.4772 11.513C17.6183 11.3637 17.693 11.2215 17.693 11.058C17.693 10.7879 17.444 10.5746 17.0954 10.5746H12.4066L14.8796 4.81591C15.2033 4.08364 14.3154 3.69263 13.7593 4.29693L6.21577 12.3661C6.07469 12.5226 6 12.6647 6 12.8211Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_257_9954">
            <rect width="12" height="16" fill="white" transform="translate(6 4)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}
